import { ConfettiConfig } from "./Config";
import Random from "./Random";
import Renderer from "./Renderer";
import Vector2D from "./Vector2D";

export default class Particle {
    private config: ConfettiConfig;
    private position: Vector2D;
    private size: Vector2D;
    private velocity: Vector2D;
    private rotation: number;
    private rotationSpeed: number;
    private color: string | number;
    private opacity: number;
    private fadeRate: number;

    constructor(config: ConfettiConfig) {
        this.config = config;
        this.position = this.initPosition();
        this.size = this.initSize();
        this.velocity = this.initVelocity();
        this.rotation = Random.range(0, 360);
        this.rotationSpeed = Random.range(-250, 250);
        this.color = this.initColor();
        this.opacity = 100;
        this.fadeRate = 100 / Random.range(0.5, 2.5);
    }

    private initPosition(): Vector2D {
        const x = this.config.position.x;
        const y = this.config.position.y;
        return new Vector2D(x, y);
    }

    private initSize(): Vector2D {
        const x = Random.range(2, 10) * this.config.size;
        const y = Random.range(2, 4) * this.config.size;
        return new Vector2D(x, y);
    }

    private initVelocity(): Vector2D {
        const x = Random.range(-0.5, 0.5);
        const y = Random.range(-0.75, 0.25);
        const direction = new Vector2D(x, y).normalize();
        direction.x *= Random.range(0, this.config.velocity * 4);
        direction.y *= Random.range(0, this.config.velocity * 4);
        return direction;
    }

    private initColor(): string | number {
        if (this.config.color && this.config.color.length > 0) {
            const index = Math.floor(Random.range(0, this.config.color.length));
            return this.config.color[index];
        } else {
            return Random.range(0, 360);
        }
    }

    update(delta: number, damping: number): void {
        this.velocity.x += Random.range(-350, 350) * delta;
        this.velocity.y += 75 * this.size.y * delta;

        this.velocity.scale(damping);

        this.position.x += this.velocity.x * delta;
        this.position.y += this.velocity.y * delta;

        this.rotation += this.rotationSpeed * delta;

        if (this.config.fade) {
            this.opacity -= this.fadeRate * delta;
            if (this.opacity < 0) this.opacity = 0;
        }
    }

    draw(renderer: Renderer): void {
        renderer.drawRect(
            this.position,
            this.size,
            this.rotation,
            this.color,
            this.opacity
        );
    }

    cull(renderer: Renderer): boolean {
        const padding = Math.max(this.size.x, this.size.y) * 2;
        const offScreen = this.position.y > renderer.height + padding;
        return offScreen || this.opacity <= 0;
    }
}
